import { render, staticRenderFns } from "./hero.vue?vue&type=template&id=6eb2906a&"
import script from "./hero.vue?vue&type=script&lang=ts&"
export * from "./hero.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports